import { render, staticRenderFns } from "./ListParagon.vue?vue&type=template&id=659ce035&scoped=true"
import script from "./ListParagon.vue?vue&type=script&lang=ts"
export * from "./ListParagon.vue?vue&type=script&lang=ts"
import style0 from "./ListParagon.vue?vue&type=style&index=0&id=659ce035&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659ce035",
  null
  
)

export default component.exports